import React, { useEffect, useState } from "react";
import { Container, Alert, Toast, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import api from "../seller-apis/api";
import { fetchansQA, fetchQA, fetchunansQA } from "../seller-apis/apidataField";
import PaginationCom from "./common/Pagination";
import Qa_Card from "./common/QaCard";
import Myalert from "./common/Myalert";
import Header from "./common/Header";
import "./LegalPolicy.css";
import { PoliciesJson } from "../utilities/policies";

var userEmail = localStorage.getItem("Email");
function LegalPolicy() {
  const [policyIndex, setPolicyIndex] = useState(0);
  const [showPolicy, setShowPolicy] = useState(false);
  const showPolicies = (index) => {
    setPolicyIndex(index);
    setShowPolicy(true);
  };
  return (
    <>
      {!showPolicy && (
        <div className="policy-list-container">
          <div className="policies-title">Legal and Policies</div>
          <ul className="policy-list">
            {PoliciesJson.map((policy, index) => {
              return (
                <li className="main-color" onClick={() => showPolicies(index)}>
                  <div>{"> "}</div>
                  <div>{policy.title}</div>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {showPolicy ? (
        <div className="policy-content-container">
          
          <div className="policy-title">
            <div><img src="/policy-back.webp" onClick={() => setShowPolicy(false)} alt="policy" /></div>
            <div className="main-color">{PoliciesJson[policyIndex].title}</div>
          </div>
          <div className="policy-content">
            <div
              dangerouslySetInnerHTML={{__html:PoliciesJson[policyIndex].detail}}
            ></div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default LegalPolicy;
